export default __webpack_public_path__ + "static/media/wheel_1.44d109e7.svg";